export default __webpack_public_path__ + "static/media/blog-single.28c86664.jpg";